(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2225],{

/***/ 5263:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/genres",
      function () {
        return __webpack_require__(4928);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StorylinerImage": function() { return /* binding */ StorylinerImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3726);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2848);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable react/jsx-props-no-spreading */ // import node_modules






// import styles

// Define component
var StorylinerImage = function(param) {
    var className = param.className, hasShadow = param.hasShadow, hasWhiteBg = param.hasWhiteBg, height = param.height, imageId = param.imageId, isBlack = param.isBlack, isRounded = param.isRounded, isWhite = param.isWhite, title = param.title, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default().image), isBlack && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-black"]), isWhite && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-white"]), isRounded && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-rounded"]), hasShadow && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["has-shadow"]), hasWhiteBg && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["white-bg"])),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            alt: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            className: className,
            height: height,
            layout: "responsive",
            loading: "lazy",
            src: imageId,
            title: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            width: width
        })
    });
};
StorylinerImage.defaultProps = {
    className: undefined,
    hasShadow: undefined,
    hasWhiteBg: undefined,
    isBlack: false,
    isRounded: true,
    isWhite: false
};
StorylinerImage.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    hasShadow: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    hasWhiteBg: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    height: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired,
    imageId: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    isBlack: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isRounded: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isWhite: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    width: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (StorylinerImage);


/***/ }),

/***/ 3192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(603);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4468);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7058);
/* harmony import */ var jotai_immer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8387);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6198);
/* harmony import */ var _atoms_Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9748);
/* harmony import */ var _modules_jotai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1262);
/* harmony import */ var _EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4370);
/* harmony import */ var _EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9__);
// import node_modules







// import types

// import components

// import modules

// import styles

// define component
var EarlyAccessSection = function(param) {
    var bgColor = param.bgColor;
    // init hooks
    var _useImmerAtom = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,jotai_immer__WEBPACK_IMPORTED_MODULE_7__/* .useImmerAtom */ .It)(_modules_jotai__WEBPACK_IMPORTED_MODULE_5__/* .earlyAccessModalAtom */ .KR), 2), setEarlyAccessModalState = _useImmerAtom[1];
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)("components").t;
    // init func
    var onOpenModal = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function() {
        setEarlyAccessModalState(function() {
            return true;
        });
    }, [
        setEarlyAccessModalState
    ]);
    // render section
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        bgColor: bgColor,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section-header"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                            alignment: "center",
                            isHyphenated: false,
                            tag: "h2",
                            children: t("EarlyAccessSection.title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            alignment: "center",
                            children: t("EarlyAccessSection.intro")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-button"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                            color: "dark",
                            text: t("EarlyAccessSection.callToAction.label"),
                            size: "large",
                            onClick: onOpenModal
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-scribble"])
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section-helptext-container"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                        alignment: "center",
                        isHelpText: true,
                        size: "small",
                        children: t("EarlyAccessSection.creditCard")
                    })
                })
            ]
        })
    });
};
EarlyAccessSection.defaultProps = {
    bgColor: "white"
};
EarlyAccessSection.propTypes = {
    bgColor: prop_types__WEBPACK_IMPORTED_MODULE_10__.oneOf(Object.values(_types__WEBPACK_IMPORTED_MODULE_3__/* .SectionColorEnum */ .TJ))
};
/* harmony default export */ __webpack_exports__["default"] = (EarlyAccessSection);


/***/ }),

/***/ 6557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GenresGrid; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@storylinerlabs/templates/dist/index.modern.js + 60 modules
var index_modern = __webpack_require__(1860);
// EXTERNAL MODULE: ./src/types/index.ts + 5 modules
var types = __webpack_require__(6198);
// EXTERNAL MODULE: ./src/components/atoms/Column.tsx
var Column = __webpack_require__(4992);
// EXTERNAL MODULE: ./src/components/atoms/Section.tsx
var Section = __webpack_require__(9748);
// EXTERNAL MODULE: ./node_modules/@storylinerlabs/design/dist/design.esm.js + 119 modules
var design_esm = __webpack_require__(4468);
// EXTERNAL MODULE: ./src/components/atoms/StorylinerImage.tsx
var StorylinerImage = __webpack_require__(4090);
// EXTERNAL MODULE: ./src/components/cards/GenreCard.module.css
var GenreCard_module = __webpack_require__(7121);
var GenreCard_module_default = /*#__PURE__*/__webpack_require__.n(GenreCard_module);
;// CONCATENATED MODULE: ./src/components/cards/GenreCard.tsx
/* eslint-disable react/forbid-prop-types */ // import node_modules




// import components

// import styles

// define component
var GenreCard = function(param) {
    var name = param.name, image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (GenreCard_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (GenreCard_module_default()).card,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (GenreCard_module_default()).cardImageContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StorylinerImage["default"], {
                        className: (GenreCard_module_default()).cardImage,
                        height: 540,
                        imageId: image,
                        title: name,
                        width: 540
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (GenreCard_module_default()).cardNameContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_esm/* Heading */.X6, {
                        tag: "h4",
                        children: name
                    })
                })
            ]
        })
    });
};
GenreCard.propTypes = {
    name: prop_types.string.isRequired,
    image: prop_types.string.isRequired
};
GenreCard.displayName = "GenreCard";
/* harmony default export */ var cards_GenreCard = (GenreCard);

// EXTERNAL MODULE: ./src/components/grids/GenresGrid.module.css
var GenresGrid_module = __webpack_require__(9888);
var GenresGrid_module_default = /*#__PURE__*/__webpack_require__.n(GenresGrid_module);
;// CONCATENATED MODULE: ./src/components/grids/GenresGrid.tsx
// import node_modules



// import types


// import components



// import styles

// define component
var GenresGgrid = function(param) {
    var bgColor = param.bgColor, templateGenres = param.templateGenres;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.ZP, {
        bgColor: bgColor,
        isPaddingLess: true,
        mobileFlexDirection: "row",
        zIndex: 1,
        children: [
            templateGenres.map(function(genre) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                    className: (GenresGrid_module_default()).column,
                    isPaddingless: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_GenreCard, {
                        name: genre.name,
                        image: genre.coverImageSquared
                    })
                }, genre.slug);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                className: (GenresGrid_module_default()).column,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
            })
        ]
    });
};
GenresGgrid.propTypes = {
    bgColor: prop_types.oneOf(Object.values(types/* SectionColorEnum */.TJ)).isRequired,
    templateGenres: prop_types.arrayOf(prop_types.shape({
        coverImageSquared: prop_types.string.isRequired,
        name: prop_types.string.isRequired,
        slug: prop_types.oneOf(Object.values(index_modern/* TemplateGenreSlugEnum */.V)).isRequired
    }).isRequired).isRequired
};
/* harmony default export */ var GenresGrid = (GenresGgrid);


/***/ }),

/***/ 6009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6198);
/* harmony import */ var _atoms_Column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4992);
/* harmony import */ var _atoms_Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9748);
/* harmony import */ var _atoms_StorylinerImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4090);
/* eslint-disable jsx-a11y/alt-text */ // import node_modules



// import types

// import components



// define component
var LogosGrid = function(param) {
    var bgColor = param.bgColor, logos = param.logos;
    // init vars
    var isBlack = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return bgColor === _types__WEBPACK_IMPORTED_MODULE_2__/* .SectionColorEnum.energyYellow */ .TJ.energyYellow;
    }, [
        bgColor
    ]);
    // init render
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        bgColor: bgColor,
        mobileFlexDirection: "row",
        zIndex: 1,
        children: logos === null || logos === void 0 ? void 0 : logos.map(function(logo) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                cols: 5,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_StorylinerImage__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    height: 360,
                    title: logo.alt,
                    isWhite: !isBlack,
                    isBlack: isBlack,
                    imageId: logo.src,
                    width: 720
                })
            }, logo.src);
        })
    });
};
LogosGrid.propTypes = {
    bgColor: prop_types__WEBPACK_IMPORTED_MODULE_6__.oneOf(Object.values(_types__WEBPACK_IMPORTED_MODULE_2__/* .SectionColorEnum */ .TJ)).isRequired,
    logos: prop_types__WEBPACK_IMPORTED_MODULE_6__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_6__.shape({
        alt: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
        src: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired
    }).isRequired).isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (LogosGrid);


/***/ }),

/***/ 5459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4468);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7058);
/* harmony import */ var _storylinerlabs_templates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1860);
/* harmony import */ var _atoms_Column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4992);
/* harmony import */ var _elements_EarlyAccessSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3192);
/* harmony import */ var _grids_GenresGrid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6557);
/* harmony import */ var _atoms_LinkComponent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2964);
/* harmony import */ var _grids_LogosGrid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6009);
/* harmony import */ var _layouts_MainLayout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6880);
/* harmony import */ var _meta_SEO__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8897);
/* harmony import */ var _atoms_Section__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9748);
// import node_modules





// import types

// import component








// define page
var GenresPage = function(param) {
    var hrefLang = param.hrefLang, templateGenres = param.templateGenres;
    // init hooks
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_12__/* .useTranslation */ .$)("genres").t;
    // init render
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_meta_SEO__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                description: t("seo.description"),
                hrefLang: hrefLang,
                image: t("seo.image"),
                title: t("seo.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_atoms_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                                height: "64px"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                                mobileHeight: "25px",
                                tabletHeight: "50px",
                                height: "75px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_atoms_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            cols: "ml",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                                    alignment: "center",
                                    children: t("hero.title")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                    alignment: "center",
                                    size: "large",
                                    children: t("hero.intro")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        bgImage: t("genres.dividerTop"),
                        bgImageDark: t("genres.dividerTopDark"),
                        bgPosition: "center top",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            mobileHeight: "100px",
                            tabletHeight: "125px",
                            height: "175px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        bgColor: "desertStorm",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            cols: "ml",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                                alignment: "center",
                                tag: "h2",
                                children: t("genres.title")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_grids_GenresGrid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        bgColor: "desertStorm",
                        templateGenres: templateGenres
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        bgColor: "desertStorm",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                                height: "50px"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        bgColor: "allports",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            height: "75px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        bgColor: "allports",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_atoms_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            cols: "prose",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                                    alignment: "center",
                                    tag: "h3",
                                    isWhite: true,
                                    children: t("innovationPartner.title")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                    alignment: "center",
                                    isWhite: true,
                                    children: t("innovationPartner.intro")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        bgColor: "allports",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Column__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            cols: "lg",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_grids_LogosGrid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                bgColor: "allports",
                                logos: t("innovationPartner.logos", {
                                    returnObjects: true
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        bgColor: "allports",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            height: "36px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_atoms_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        bgColor: "allports",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_LinkComponent__WEBPACK_IMPORTED_MODULE_7__["default"], {
                                href: t("innovationPartner.callToAction.link"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .LinkButton */ .Qj, {
                                    color: "naked",
                                    iconRight: "ri-mail-send-line",
                                    size: "large",
                                    text: t("innovationPartner.callToAction.label"),
                                    textIsWhite: true
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                                height: "25px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        bgImage: t("innovationPartner.dividerBottom"),
                        bgImageDark: t("innovationPartner.dividerBottomDark"),
                        bgPosition: "center bottom",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            mobileHeight: "100px",
                            tabletHeight: "125px",
                            height: "175px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            height: "100px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_EarlyAccessSection__WEBPACK_IMPORTED_MODULE_5__["default"], {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
                            height: "100px"
                        })
                    })
                ]
            })
        ]
    });
};
GenresPage.propTypes = {
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_13__.string.isRequired,
    templateGenres: prop_types__WEBPACK_IMPORTED_MODULE_13__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_13__.shape({
        slug: prop_types__WEBPACK_IMPORTED_MODULE_13__.oneOf(Object.values(_storylinerlabs_templates__WEBPACK_IMPORTED_MODULE_3__/* .TemplateGenreSlugEnum */ .V)).isRequired,
        coverImageSquared: prop_types__WEBPACK_IMPORTED_MODULE_13__.string.isRequired,
        name: prop_types__WEBPACK_IMPORTED_MODULE_13__.string.isRequired
    }).isRequired).isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (GenresPage);


/***/ }),

/***/ 4928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _storylinerlabs_templates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1860);
/* harmony import */ var _components_templates_GenresTemplate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5459);
// import node_modules




// import components

// define page
var GenresPage = function(param) {
    var hrefLang = param.hrefLang, templateGenres = param.templateGenres;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_GenresTemplate__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        hrefLang: hrefLang,
        templateGenres: templateGenres
    });
};
GenresPage.propTypes = {
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    templateGenres: prop_types__WEBPACK_IMPORTED_MODULE_4__.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_4__.shape({
        slug: prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf(Object.values(_storylinerlabs_templates__WEBPACK_IMPORTED_MODULE_2__/* .TemplateGenreSlugEnum */ .V)).isRequired,
        coverImageSquared: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
        name: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
    }).isRequired).isRequired
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (GenresPage);


/***/ }),

/***/ 2848:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"storyliner-vbD9mK","fade-in":"storyliner-eNwawO","is-rounded":"storyliner-kV1a7W","is-white":"storyliner-FVEYZh","is-black":"storyliner-dc3Q7B","has-shadow":"storyliner-QcsozF","white-bg":"storyliner-bi4CsT"};

/***/ }),

/***/ 7121:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardNameContainer":"storyliner-YbTrb6","cardImage":"storyliner-PiY6Eg","cardImageContainer":"storyliner-hTxDXt","card":"storyliner-fGy17P","container":"storyliner-ZnSpWa"};

/***/ }),

/***/ 4370:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"storyliner-early-access-section":"storyliner-wwGQfR","storyliner-early-access-section-header":"storyliner-idzssv","storyliner-early-access-button":"storyliner-oIUwVo","storyliner-early-access-scribble":"storyliner-gRgBcx","storyliner-early-access-section-helptext-container":"storyliner-VU7xmS"};

/***/ }),

/***/ 9888:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"column":"storyliner-2QeAbJ"};

/***/ }),

/***/ 4654:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4348,2539,1860,675,6880,8196,9774,2888,179], function() { return __webpack_exec__(5263); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);